import { createFileRoute, redirect } from "@tanstack/react-router";

/** One list of document types for the whole of HR, and it lives under HR. */
export const Route = createFileRoute("/_authenticated/_workforce/hiring/document-types")({
  beforeLoad: () => {
    throw redirect({ to: "/hr/document-types" });
  },
});
